import React from 'react'
import unCheck from "../../../Images/unCheck.svg";
import Check from "../../../Images/check.svg";
import ProgressIndicator1 from "../../../Images/ProgressIndicator/progressIndicator1.svg";
import ProgressIndicator0 from "../../../Images/ProgressIndicator/progressIndicator0.svg";
import ProgressIndicator100 from "../../../Images/ProgressIndicator/progressIndicatorFull.svg";
import ProgressIndicator25 from "../../../Images/ProgressIndicator/ProgressIndicator25.svg";
import ProgressIndicator50 from "../../../Images/ProgressIndicator/ProgressIndicator50.svg";
import ProgressIndicator75 from "../../../Images/ProgressIndicator/ProgressIndicator75.svg";
import ProgressIndicator33 from "../../../Images/ProgressIndicator/ProgressIndicator33.svg";
import ProgressIndicator66 from "../../../Images/ProgressIndicator/ProgressIndicator66.svg";



const ProbingTab = (probs) => {
    const {probingCheck, item ,handleRadioChange } = probs

//     const radioList = item.value.split('\n')
//   .map(instruction => instruction.trim()) // Trim any leading or trailing whitespace
//   .filter(instruction => instruction.length > 0); // Filter out empty instructions

const parser = new DOMParser();
    const doc = parser.parseFromString(item, 'text/html');

    const elements = doc.body.childNodes;

    // Initialize an array to hold radio button options
    const radioButtons = [];
    let listItems

    elements.forEach((element, index) => {
        let items = [];
  
        if (element?.tagName === 'P' || element?.tagName === 'LI') {
          items = [{ text: element?.textContent.trim(), value: `option-${index}` }];
        } else if (element?.tagName === 'UL' || element?.tagName === 'OL') {
          items = Array.from(element?.children).map((child, childIndex) => ({
            text: child.textContent.trim(),
            value: `option-${index}-${childIndex}`,
          }));
        }

        listItems=items
        items?.forEach((item) => {
            radioButtons.push(
                <div key={item.value} style={{ marginLeft: '20px', overflowWrap: 'break-word' , display : 'flex' , alignItems : 'center', margin : '10px 14px 14px 14px'}} className='system-check-para'>
                <img
                    id={item.value}
                    name="probing"
                    alt="radioCheck"
                    value={item.text}
                    src={probingCheck?.includes(item.text) ? Check : unCheck}
                    onClick={() => handleRadioChange(item.text)}
                    style={{
                        width: "20px",
                        height: "20px",
                        position: "relative",
                        left: "2px",
                        marginTop:'2px',
                        cursor:'pointer'
                    }}
                />
                 <div
                    className="probe-list"
                    htmlFor={item.text}
                    style={{
                        textDecoration: probingCheck?.includes(item.text)
                            ? "line-through"
                            : "none",
                        marginLeft: "14px",
                        color: "#220046",
                        alignItems: "center",
                        display: "flex",
                    }}
                >
                    {item.text}
                </div>
            </div>
            );
          });
        });

    // Extract the list items
    // const listItems = Array.from(doc.querySelectorAll('li'));

    const probingLength = probingCheck?.length || 0;
    const totalLength = listItems?.length || 0;

    const progressPercentage = totalLength === 0 ? 0 : (probingLength / totalLength) * 100;

    let progressLevel;
    if (progressPercentage === 0) {
        progressLevel = 0;
    } else if (progressPercentage <= 25) {
        progressLevel = 25;
    }else if (progressPercentage <= 33){
        progressLevel = 33;
    } else if (progressPercentage <= 50) {
        progressLevel = 50;
    } else if(progressPercentage <= 66){
        progressLevel = 66;
    }else if (progressPercentage <= 75) {
        progressLevel = 75;
    } else {
        progressLevel = 100;
    }

    const getProgressIndicatorSrc = (level) => {
        switch (level) {
          case 0:
            return ProgressIndicator0;
          case 25:
            return ProgressIndicator25;
          case 33:
            return ProgressIndicator33;
          case 50:
            return ProgressIndicator50;
          case 66:
            return ProgressIndicator66;
          case 75:
            return ProgressIndicator75;
          case 100:
            return ProgressIndicator100;
          default:
            return ProgressIndicator0;
        }
      };

    return (
        <div>
            <div className="sub-headers-probe">
                <div className="header-prob">PROBING</div>
                <span className="sub-header-page">
                    <div
                        style={{ display: "flex", width: "52px", gap: "8px" }}
                    >
                        <div className="selected-probe">
                            {probingCheck?.length || 0}/{listItems?.length || 0}
                        </div>
                        <img
                            style={{ width: "24px", height: "24px" }}
                            src={probingCheck?.length === 0 ? ProgressIndicator0 : getProgressIndicatorSrc(progressLevel)}
                            alt="attach"
                        />
                    </div>
                </span>
            </div>
            {radioButtons}

        </div>
    )
}

export default ProbingTab
